import React, { useContext, useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { MsalContext } from '../Contexts/MsalContext';

export default function UserNameDisplay() {
    const { msalFetch } = useContext(MsalContext);
    const [name, setName] = useState('Unknown');

    useEffect(() => {
        msalFetch('api/User/getUserName')
            .then(response => response.text())
            .then(data => {
                var formattedName = data.split('@')[0];
                var array = formattedName.split('.');
                for (var i = 0; i < array.length; i++) {
                    array[i] = array[i].charAt(0).toUpperCase() + array[i].slice(1);
                }
                formattedName = array.join(' ');
                setName(formattedName);
            });
    }, []);

    return (
        <Typography variant="body1" align="right" style={{ color: "var(--light-text)", textTransform: "none" }}>{name}</Typography>
    );
}